import { useQuery } from '@tanstack/react-query';
import { partnersApi, PartnerRecord } from '../api/partners';

/**
 * Every partner record on the tenant's roster, any status — the admin
 * table's data source, and (found by id) the detail page's status sidebar.
 * Separate query key from usePartnerQueue's submitted-only scope, so the two
 * don't fight over the same cache entry.
 */
export function usePartnerRecords() {
  const { data: form } = useQuery({
    queryKey: ['partner-form'],
    queryFn: partnersApi.getForm,
  });

  const { data: records, isLoading } = useQuery<PartnerRecord[]>({
    queryKey: ['partner-records', form?.id],
    queryFn: () => partnersApi.getRecords(form!.id),
    enabled: form != null,
  });

  return { formId: form?.id, records, isLoading: isLoading || form === undefined };
}
